import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const SortableHeader = ({ field, label, sortBy, sortOrder, onSort, align = 'left', className = '' }) => {
  const isActive = sortBy === field;

  const handleClick = () => {
    onSort(field);
  };

  const alignmentClasses = {
    left: 'justify-start text-left',
    right: 'justify-end text-right',
    center: 'justify-center text-center',
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex items-center gap-1 truncate font-semibold hover:opacity-80 transition-opacity ${alignmentClasses[align]} ${className}`}
    >
      <span className="truncate">{label}</span>

      {isActive &&
        (sortOrder === 'asc' ? (
          <ArrowUp size={16} strokeWidth={2} className="text-tealMedium" />
        ) : (
          <ArrowDown size={16} strokeWidth={2} className="text-tealMedium" />
        ))}
    </button>
  );
};

export default SortableHeader;
